<template>
  <Head :title="`Home - ${client.name}`" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-4">
        <div class="col p-0">
          <landing-page 
            :user="auth.user" 
            :client="client" 
            :playbooks="playbooks" 
            :published_plan="published_plan" 
            :active_plan="active_plan"
            :notifications="auth.user.unread_notifications"
          ></landing-page>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../Layouts/AppLayout.vue';

defineProps({
  auth: Object,
  client: Object,
  playbooks: Array,
  published_plan: {
    type: Object,
    default: null
  },
  active_plan: {
    type: Object,
    default: null
  }
});
</script>

